// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Button_wrapper__Sjioc","iconOnly":"Button_iconOnly__1EYmM","isLink":"Button_isLink__o_wBD","largeIcon":"Button_largeIcon__zi-d3","blueHover":"Button_blueHover__1PlF0"};